/* dynamic-layout-smart-link.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./dynamic-layout-smart-link.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import FileIcon from '@atlaskit/icon/core/file';
import PageIcon from '@atlaskit/icon/core/page';
import PullRequestIcon from '@atlaskit/icon/core/pull-request';
import VideoIcon from '@atlaskit/icon/core/video';
import Image from '@atlaskit/image';
import { Anchor, Box, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import { Card } from '@atlaskit/smart-card';
import { useFetchSmartLinkData } from '../../hooks/useFetchSmartLinkData';
var useEmbedInlineCardUrlPrefix = ['https://www.loom.com/', 'https://docs.google.com/'];
var styles = {
  anchor: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _9oik1r31 _1bnxglyw _jf4cnqa1",
  container: "_2rko12b0 _1bsbaq3k _bfhkysee _irr3wejn _d0altlke",
  embedContainer: "_2rko12b0 _1bsb14gx _bfhkysee _hmmtj0fz _1kbq1mok _t1hxv77o _1g3i15vq _1m5815vq _19201jia _10j45d63 _1dzt15ob _1spg15ob _17c314gx _f1b9y5e7 _q3ol1txw _b1g11bp4 _z0rj1yb4 _172kusvi _cghhkb7n _iiduglyw _irr3wejn _d0altlke",
  content: "_1bsbaq3k _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
  titleBox: "_p12f1wdt",
  summaryBox: "_19pkpxbi _p12f5x59",
  pageIconWrapper: "_2rko12b0 _4t3izwfg _1bsbzwfg _vchhusvi _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _1e0c1txw _1bah1h6o _4cvr1h6o _bfhki8nm",
  documentMetadataIconWrapper: "_4t3i7vkz _1bsb7vkz"
};
var getDocumentIcon = function getDocumentIcon(itemData) {
  if (itemData.url && itemData.url.includes('docs.google.com')) {
    return /*#__PURE__*/React.createElement(FileIcon, {
      color: "var(--ds-icon-success, #6A9A23)",
      label: ""
    });
  }
  if (itemData.url && itemData.url.includes('loom.com')) {
    return /*#__PURE__*/React.createElement(VideoIcon, {
      color: "var(--ds-icon-discovery, #AF59E1)",
      label: ""
    });
  }
  if (itemData.url && (itemData.url.includes('bitbucket.org') || itemData.url.includes('github.com'))) {
    return /*#__PURE__*/React.createElement(PullRequestIcon, {
      color: "var(--ds-icon-accent-green, #22A06B)",
      label: ""
    });
  }
  return /*#__PURE__*/React.createElement(PageIcon, {
    color: "var(--ds-icon-brand, #1868DB)",
    label: ""
  });
};
var EmbedInlineCard = function EmbedInlineCard(_ref) {
  var url = _ref.url;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.embedContainer
  }, /*#__PURE__*/React.createElement(Card, {
    appearance: "embed",
    url: url,
    actionOptions: {
      hide: false
    },
    inheritDimensions: true
  }));
};
export var DynamicLayoutSmartLinkInternal = function DynamicLayoutSmartLinkInternal(_ref2) {
  var _component$attributes, _resolvedData$generat;
  var component = _ref2.component;
  var url = ((_component$attributes = component.attributes) === null || _component$attributes === void 0 ? void 0 : _component$attributes.url) || '';
  var _useFetchSmartLinkDat = useFetchSmartLinkData({
      urls: [url]
    }),
    objectResolverData = _useFetchSmartLinkDat.objectResolverData;
  var resolvedData = objectResolverData === null || objectResolverData === void 0 ? void 0 : objectResolverData[0];
  var userMetadata = (resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData['atlassian:ownedBy']) || (resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData.attributedTo);
  return resolvedData ? /*#__PURE__*/React.createElement(Anchor, {
    href: url,
    xcss: styles.anchor,
    "aria-label": "",
    tabIndex: -1
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.container
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.content
  }, /*#__PURE__*/React.createElement(Inline, {
    space: "space.150",
    alignBlock: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.pageIconWrapper
  }, getDocumentIcon(resolvedData)), /*#__PURE__*/React.createElement(Stack, {
    space: "space.050"
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.titleBox
  }, /*#__PURE__*/React.createElement(Text, {
    maxLines: 1
  }, resolvedData.name)), resolvedData.generator && /*#__PURE__*/React.createElement(Inline, {
    space: "space.050"
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.documentMetadataIconWrapper
  }, /*#__PURE__*/React.createElement(Image, {
    src: (_resolvedData$generat = resolvedData.generator.icon) === null || _resolvedData$generat === void 0 ? void 0 : _resolvedData$generat.url,
    alt: ""
  })), /*#__PURE__*/React.createElement(Text, {
    color: "color.text.subtle",
    size: "small",
    maxLines: 1
  }, resolvedData.generator.name), /*#__PURE__*/React.createElement(Text, {
    color: "color.text.subtle",
    size: "small"
  }, userMetadata !== null && userMetadata !== void 0 && userMetadata.name ? "\u2022 ".concat(userMetadata.name) : '')))), /*#__PURE__*/React.createElement(Box, {
    xcss: styles.summaryBox
  }, /*#__PURE__*/React.createElement(Stack, {
    space: "space.050"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "color.text.subtle",
    size: "small",
    maxLines: 3
  }, resolvedData.summary)))))) : null;
};
export var DynamicLayoutSmartLink = function DynamicLayoutSmartLink(_ref3) {
  var _component$attributes2;
  var component = _ref3.component;
  var url = ((_component$attributes2 = component.attributes) === null || _component$attributes2 === void 0 ? void 0 : _component$attributes2.url) || '';
  if (useEmbedInlineCardUrlPrefix.some(function (prefix) {
    return url.startsWith(prefix);
  })) {
    return /*#__PURE__*/React.createElement(EmbedInlineCard, {
      url: url
    });
  }
  return /*#__PURE__*/React.createElement(DynamicLayoutSmartLinkInternal, {
    component: component
  });
};